export default __webpack_public_path__ + "media/images/dividers/inverse-white-rip-e1245c649230a8e37838e461d7b473b6.svg";